import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './oper-exped.css'
import grupos from '../../../data/cdcGroups.json'
import CardDefault from "../../../components/cdc/card-default/CardDefault";
import PerformanceStatistics from "../../../components/cdc/performance-statistics/PerformanceStatistics";
import Movimentations from "../../../components/cdc/movimentations/Movimentations";



class OperExped extends React.Component {
    
    constructor(props) {
        super(props)

        this.state = {
            alert: { msg: 'Preecha os filtros para começar', type: '' },
            loading: false,
            filter: {
                dataInicio: "",
                dataFim: "",
                origem: "",
                destino: "",
                grupo: grupos[1].value,
            },
            graph: false,
            topCards: [],
            botCards: [],
            estatistico: {},
            movimentacoes: [],
            defaltEstrategicValue: { label: 'Último 6 meses', value: 6 },
            loadingEstatistico: true,
        }
    }

    getDash = data => {
        console.log(data)
        this.setState({ loading: true, table: [], alert: {}, graph: false });
        axios.post(`${url}/v1/telemetria/controleCarga/kpi/expedicao/${this.props.token}`, data)
            .then(d => {
                let topCards = [
                    { label: 'TMS - Tempo Médio de Serviço', value: d.data.tms.value, percent: d.data.tms.percent, img: 'cdc-03' },
                    { label: 'TMP - Tempo Médio de Paradas', value: d.data.tmp.value, percent: d.data.tms.percent, red: true, img: 'none' },
                    { label: 'Cargas por Motorista', value: d.data.cargasMotorista, red: true, img: 'cdc-03' },
                    { label: 'Tempo Médio por Motorista', value: d.data.tmm.value, percent: d.data.tmm.percent, red: true, img: 'cdc-03' },
                ]

                let movimentacoes = [
                    { label: "Coletas", value: d.data.movimentacoes.totalColetas, color: "#FE8373" },
                    { label: "Inter Fábrica", value: d.data.movimentacoes.totalInterFabrica, color: "#FFDA82" },
                    { label: "Viagens", value: d.data.movimentacoes.totalViagem, color: "#53D8FE" }
                ]

                let botCards = [
                    { label: 'Custo de Viagens', value: '0000', percent: '13%', red: true, img: 'cdc-01' },
                    { label: 'Horas extras', value: d.data.horasExtra.value, percent: d.data.horasExtra.percent, red: true, img: 'cdc-03' },
                    { label: 'Horas em direção', value: d.data.horasDirecao, img: 'cdc-03' },
                ]

                this.setState({
                    loading: false,
                    graph: true,
                    topCards,
                    movimentacoes,
                    botCards,

                })

                this.getEstrategico(6)
                console.log(d.data)
            }).catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    getEstrategico = meses => {
        let filter = {
            origem: this.state.filter.origem,
            destino: this.state.filter.destino,
            grupo: this.state.filter.grupo,
            meses
        }
        console.log(filter)
        this.setState({ loadingEstatistico: true })
        axios.post(`${url}/v1/telemetria/controleCarga/kpi/expedicao/estatistica/${this.props.token}`, filter)
            .then(d => {
                console.log(d.data)
                let estatistico = {
                    meses: d.data.meses,
                    option1: d.data.data[0],
                    option2: d.data.data[1]
                }
                this.setState({ loadingEstatistico: false, estatistico })
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })

    }

    handleMovimentationFilter = i => {
        console.log(i)
        this.setState({ defaltEstrategicValue: i })
        this.getEstrategico(i.value)
    };

    exportDash = body => {
        console.log(body)
        this.setState({ loading: true });

        axios
            .request({
                url: `${url}/v1/telemetria/controleCarga/kpi/exportData/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    columns: this.state.table.columns,
                    responseType: "blob"
                }
            })
            .then(({ data }) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `strategic--${body.dataInicio}--${body.dataFim}.csv`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };


    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, dataInicio: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()}
                        value={this.state.filter.dataInicio} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, dataFim: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.dataInicio}
                        min={this.state.filter.dataInicio}
                        value={this.state.filter.dataFim}
                    />
                </div>
                <div>
                    <label htmlFor="origem" className='toolbar-label'>Origem</label>
                    <input
                        id='origem'
                        placeholder="Origem"
                        maxLength={3}
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, origem: i.target.value } })}
                        disabled={this.state.loading}
                        value={this.state.filter.orgiem}
                    />
                </div>
                <div>
                    <label htmlFor="destino" className='toolbar-label'>Destino</label>
                    <input
                        id='destino'
                        placeholder="Destino"
                        maxLength={3}
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, destino: i.target.value } })}
                        disabled={this.state.loading}
                        value={this.state.filter.destino}
                    />
                </div>
                <div>
                    <label htmlFor="groups" className='toolbar-label'>Grupo</label>
                    {/* Select Grupos */}
                    <Select
                        // isDisabled={this.state.loading}
                        // isLoading={this.state.collab.loading}
                        inputId='groups'
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Grupo"
                        noOptionsMessage={e => { return `"${e.inputValue}" não foi encontrado!` }}
                        options={grupos}
                        closeMenuOnSelect={true}
                        defaultValue={grupos[1]}
                        onChange={(i) => {
                            console.log(i)
                            this.setState({ filter: { ...this.state.filter, grupo: i.value } })
                        }}
                        isDisabled={this.state.loading} />
                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getDash(this.state.filter)}
                    disabled={!this.state.filter.dataInicio || !this.state.filter.dataFim || this.state.filter.grupo < 1 || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.graph ? (
                    <div className=''>
                        <input
                            type="button"
                            value='Exportar CSV'
                            className='excel-button'
                            onClick={() => this.exportDash(this.state.filter)}
                            style={{ marginBottom: '20px', marginLeft: '12px' }}
                            disabled={this.state.loading}
                        />
                        <div className="row row-inside">
                            {/* Cards Superiores */}

                            <div className="col-12 no-padding">
                                <div className="row row-inside">

                                    {this.state.topCards.map((d, i) => {
                                        return (
                                            <div className='col-lg-3 col-md-6' key={i}>
                                                <CardDefault data={d} />
                                            </div>

                                        )
                                    })}
                                </div>
                            </div>

                            <div className="col-lg-12 col-xl-7">
                                {this.state.loadingEstatistico ? (
                                    <div className='app-tool-center-loading loading-dash-statistics' style={{ height: '349px' }}>
                                        <Loading />
                                    </div>
                                ) : (
                                    <div>
                                        <PerformanceStatistics
                                            options={[
                                                { label: 'Último 3 meses', value: 3 },
                                                { label: 'Último 6 meses', value: 6 },
                                                { label: 'Último 12 meses', value: 12 }
                                            ]}
                                            defaltEstrategicValue={this.state.defaltEstrategicValue}
                                            _handle={this.handleMovimentationFilter}
                                            data={this.state.estatistico}
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Movimentações */}
                            <div className="col-lg-12 col-xl-5 mg-movimentation">
                                <Movimentations data={this.state.movimentacoes} />
                            </div>

                            {/* Card Inferiores */}
                            <div className="col-12 no-padding mg-inferior">
                                <div className="row row-inside">

                                    {this.state.botCards.map((d, i) => {
                                        return (
                                            <div className='col-lg-4 col-md-6' key={i}>
                                                <CardDefault data={d} />
                                            </div>

                                        )
                                    })}
                                </div>
                            </div>



                        </div>
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default OperExped